"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeArray = void 0;
exports.IkeArray = {
    /**
     *  Shallow clone a array
     *
     * @returns New array of elements
     **/
    clone: function (ary) {
        if (ary == null) {
            return [];
        }
        return ary.slice();
    },
    /**
     * Produces a duplicate-free version of the array.
     *
     * @param arr Array to iterate over.
     * @param key Key used to identify duplicate objects.
     */
    uniqueBy: function (arr, key) {
        if (!Array.isArray(arr)) {
            return [];
        }
        var seen = {};
        var uniqueArr = [];
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var item = arr_1[_i];
            if (item == null) {
                continue;
            }
            var seenKey = item[key];
            if (seenKey != null && !seen[seenKey]) {
                seen[seenKey] = true;
                uniqueArr.push(item);
            }
        }
        return uniqueArr;
    },
    /** Recursively flattens an array. */
    flatten: function (data, output) {
        if (output === void 0) { output = []; }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var ary = data_1[_i];
            if (Array.isArray(ary)) {
                exports.IkeArray.flatten(ary, output);
            }
            else {
                output.push(ary);
            }
        }
        return output;
    },
    /**
     * Convert an array of objects to a map with each unique value assigned to the provided key.
     * @param arr Objects to convert into a map
     * @param key Key inside the object to use for conversion
     */
    toMap: function (arr, key) {
        var output = {};
        for (var _i = 0, arr_2 = arr; _i < arr_2.length; _i++) {
            var obj = arr_2[_i];
            output[obj[key]] = obj;
        }
        return output;
    },
    /**
    * Convert an array of objects to a map with each array of values assigned to the provided key.
    * @param arr Objects to convert into a map
    * @param key Key inside the object to use for conversion
    */
    groupBy: function (arr, key) {
        var output = {};
        for (var _i = 0, arr_3 = arr; _i < arr_3.length; _i++) {
            var obj = arr_3[_i];
            var value = obj[key];
            if (output[value] == null) {
                output[value] = [obj];
            }
            else {
                output[value].push(obj);
            }
        }
        return output;
    },
    /**
     * Get the values in one array which are not found in the second.
     * Both arrays are treated as sets.
     *
     * @param arr1 Original Array
     * @param arr2 Other Array
     * @returns Values of `arr1` not in `arr2`
     */
    difference: function (arr1, arr2) {
        var store = new Set(arr2);
        var result = [];
        for (var _i = 0, arr1_1 = arr1; _i < arr1_1.length; _i++) {
            var value = arr1_1[_i];
            if (!store.has(value)) {
                result.push(value);
            }
        }
        return result;
    },
    // differenceObj<T>(arr1: T[], arr2: T[], key): T[];
    /**
     * Creates an array of elements split into groups the length of size. If array can't be split evenly, the final chunk will be the remaining elements.
     *
     * @param array The array to process.
     * @param size The length of each chunk.
     * @returns The new array of chunks.
     */
    chunk: function (array, size) {
        var chunks = [];
        if (array == null || array.length === 0) {
            return chunks;
        }
        var count = Math.ceil(array.length / size);
        for (var i = 0; i < count; i++) {
            var currentChunk = array.slice(i * size, (i + 1) * size);
            chunks.push(currentChunk);
        }
        return chunks;
    }
};
//# sourceMappingURL=array.js.map